import { ITabsContext } from "../providers/tabsProvider";

export const openTab = (tabCtx: ITabsContext, mnemocode: IPlugin) => {
    let openedTab = tabCtx.tabs.find(x => x.view.content.props?.plugin?.mnemocode === mnemocode)
    if (openedTab) {
        tabCtx.activate(openedTab)
    } else {
        tabCtx.open(mnemocode)
    }
}